/**
 * ImagePreview Component
 * 
 * Shows selected images before sending with:
 * - Thumbnail previews
 * - Remove button (X) on each image
 * - Grid layout for multiple images
 */

import React from 'react';
import { X } from 'lucide-react';
import LocalImageThumb from '@/components/shared/LocalImageThumb';

export default function ImagePreview({ images, onRemove, onClear }) {
  if (!images || images.length === 0) return null;

  return (
    <div data-ui="img-strip" className="px-3 py-2 border-b border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-[#1e1f22]">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs text-slate-500 dark:text-slate-400">
          {images.length} image{images.length > 1 ? 's' : ''} selected
        </span>
        <button
          onClick={onClear}
          className="text-xs text-red-500 dark:text-red-400 hover:text-red-600"
        >
          Clear all
        </button>
      </div>
      
      <div className="flex flex-wrap gap-2">
        {images.map((image, index) => (
          <div
            key={index}
            className="relative group"
          >
            {/* Falls back to a label when the browser cannot draw the file (HEIC outside Safari) */}
            <LocalImageThumb
              src={image.preview}
              name={image.file?.name}
              alt={`Preview ${index + 1}`}
              data-ui="thumb"
              className="w-16 h-16 object-cover rounded-lg border border-slate-200 dark:border-white/10"
            />
            <button
              onClick={() => onRemove(index)}
              data-ui="thumb-rm"
              className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-md"
              title="Remove image"
            >
              <X className="w-3 h-3" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
